<template>
  <ul class="navbar-nav"><slot></slot></ul>
</template>
